import React, { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { userState } from "../../../../states/userState";
import classes from "./DateEnableSwitch.module.scss";
import { Switch } from "@mui/material";
import { foreColor } from "../../../../commons/colors";
import { User } from "../../../../types";
import { setUserToLocalStorage } from "../../../../lib/localStorageManager";
type DateEnableProps = {
  checked: boolean;
  setChecked: React.Dispatch<React.SetStateAction<boolean>>;
};

const DateEnableSwitch = (props: DateEnableProps) => {
  const [user, setUser] = useRecoilState(userState);
  const { checked, setChecked } = props;
  useEffect(() => {
    setChecked(user.filters.fromDate !== "");
  }, [user.filters.fromDate]);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(e.target.checked);
    setUser((prevUser: User) => {
      const updatedUser = {
        ...prevUser,
        filters: {
          ...prevUser.filters,
          fromDate: "",
          toDate: "",
          dateField: "完成予定",
        },
      };
      setUserToLocalStorage(updatedUser);
      return updatedUser;
    });
  };
  return (
    <div className={classes.switch}>
      <p style={foreColor(user?.mode ?? "lite")}>予定日</p>
      <Switch
        checked={checked}
        onChange={handleChange}
        sx={{
          ...(user.filters.fromDate === "" || !user.filters.fromDate
            ? { color: "#4a4f58" }
            : { color: foreColor(user?.mode ?? "lite") }),
        }}
      />
    </div>
  );
};

export default DateEnableSwitch;
